<template>
  <div>
    <b-form-input v-model="internalValue" @change="$emit('valueChanged', internalValue)" class="text-right"/>
  </div>
</template>

<script>
export default {
  props: {
    value:          0,
    modeRestricted: {
      type:    Boolean,
      default: false
    }
  },
  data() {
    return {
      internalValue: 0
    }
  },
  async created() {
    this.internalValue = this.value;
  },
  methods:    {},
  components: {}
}
</script>

<style>
</style>
